import React, { lazy, useEffect, useState } from "react";
import DateRangePicker from "react-bootstrap-daterangepicker";
import Moment from "moment";
import { format } from "date-fns";
import { Card, CardBody, CardHeader } from "./../../components/card/card.jsx";
import "bootstrap-daterangepicker/daterangepicker.css";
import StructureView from "./structure_view";
import Accordion from "react-bootstrap/Accordion";
import { machineProfile } from "../../api";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import { useDashboardContext } from "../../contexts/NewDashboardContext";
import LiveChart from "../sensor/LiveChart";
const VibrationChart = lazy(() => import("../sensor/Charts/VibrationChart"));

const getStatus = (status) => {
  switch (status) {
    case "Acceptable":
      return "accept";
    case "Observe":
      return "observe";
    case "Alert":
      return "alert";
    case "Critical":
      return "critical";
    default:
      return "pending";
  }
};

function Weekly() {
  // get latest Wednesday date
  const lastWednesday = Moment().day(-4).format("YYYY-MM-DD");
  const weekBefore = Moment(lastWednesday)
    .subtract(7, "days")
    .format("YYYY-MM-DD");
  const weekBefore2 = Moment(weekBefore)
    .subtract(14, "days")
    .format("YYYY-MM-DD");
  const nextWeek = Moment(lastWednesday).add(7, "days").format("YYYY-MM-DD");
  // get remaining days and hours example 3 days and 2 hour left for next update
  const remainingDays = Moment(nextWeek).fromNow();
  const reportDate = { startDate: weekBefore, endDate: lastWednesday };
  const reportDate2 = { startDate: weekBefore2, endDate: weekBefore };
  const { weeklyAnalytics, updateWeeklyAnalytics } = useDashboardContext();
  const [loading, setLoading] = useState(false);
  const [machineDetail, setMachineDetail] = useState(null);
  const [selectedMachine, setSelectedMachine] = useState(null);
  const [activeKey, setActiveKey] = useState(null);
  const [key, setKey] = useState("tab0");
  const [machineHealth, setMachineHealth] = useState([]);
  const [lastMachineHealth, setLastMachineHealth] = useState([]);
  var dateRange = {
    currentWeek:
      Moment().subtract(7, "days").format("D MMM YYYY") +
      " - " +
      Moment().format("D MMM YYYY"),
    prevWeek:
      Moment().subtract(15, "days").format("D MMM") +
      " - " +
      Moment().subtract(8, "days").format("D MMM YYYY"),
  };

  var startDate = "";
  var endDate = "";
  var prevDate = Moment().add(-1, "d").format("D MMM YYYY");
  var todayDate = Moment().add(-1, "d").format("D MMM YYYY");
  useEffect(() => {
    if (selectedMachine) {
      getHealth();
      getMachine();
    }
    // getMachine();
  }, [selectedMachine]);
  const getMachine = async () => {
    try {
      setLoading(true);
      const res = await machineProfile.getOne(selectedMachine?.id);
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        setMachineDetail(data);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };
  const getSensors = () => {
    const sensors = [];
    if (machineDetail && machineDetail.machine_elements) {
      machineDetail.machine_elements.map((me) => {
        if (me.deployments) {
          me.deployments.map((d) => {
            let sensor = d.sensor;
            sensor.machine_element_name = me.machine_element_name;
            sensor.machine_element_id = me.id;
            sensor.deployments_id = d.id;
            sensors.push(sensor);
          });
        }
      });
    }
    //console.log({ sensors });
    return sensors;
  };
  useEffect(() => {
    if (key) {
      updateWeeklyAnalytics({ sensor: key });
    }
  }, [key]);
  useEffect(() => {
    if (weeklyAnalytics.sensor) {
      setKey(weeklyAnalytics.sensor);
    }
  }, [weeklyAnalytics]);
  const getHealth = async () => {
    let start = "";
    let end = "";
    // start last week in format YYYY-MM-DD
    // end today in format YYYY-MM-DD
    const last_week = Moment().subtract(27, "days");
    start = last_week.toISOString().split("T")[0];
    end = new Date().toISOString().split("T")[0];

    const result = await machineProfile.listMachineHealth({
      start_date: weekBefore,
      end_date: lastWednesday,
      machine_id: selectedMachine?.id,
    });
    const result2 = await machineProfile.listMachineHealth({
      start_date: weekBefore2,
      end_date: weekBefore,
      machine_id: selectedMachine?.id,
    });

    if (result.ok) {
      const body = await result.json();
      if (body.data.length) {
        setMachineHealth(body.data);
      } else {
        setMachineHealth([]);
      }
    }
    if (result2.ok) {
      const body = await result2.json();
      if (body.data.length) {
        setLastMachineHealth(body.data);
      } else {
        setLastMachineHealth([]);
      }
    }
  };

  const MachineHealthDetail = ({ data }) => {
    return (
      <Card className="border-theme mb-3 mt-3">
        <CardHeader className="border-theme fw-bold small text-theme d-flex">
          <div className="flex-1">
            <span
              className={`badge bg-${getStatus(data.status)}`}
              style={{ color: "black" }}
            >
              {data.status}
            </span>{" "}
            Machine Health
          </div>
          <div>
            {" "}
            {format(new Date(data.created_at), "dd MMMM yyyy | HH:mm ")}
          </div>
        </CardHeader>
        <CardBody>
          <p
            className="card-text text-opacity-75"
            style={{ whiteSpace: "pre-wrap" }}
          >
            {data.description}
          </p>
        </CardBody>
      </Card>
    );
  };

  function handleDateApplyEvent(event, picker) {
    var startDate = picker.startDate;
    var endDate = picker.endDate;
    var gap = endDate.diff(startDate, "days");

    var currentWeek =
      startDate.format("D MMM YYYY") + " - " + endDate.format("D MMM YYYY");
    var prevWeek =
      Moment(startDate).subtract(gap, "days").format("D MMM") +
      " - " +
      Moment(startDate).subtract(1, "days").format("D MMM YYYY");

    dateRange.currentWeek = currentWeek;
    dateRange.prevWeek = prevWeek;
  }

  const onChangeTree = (ms) => {
    setActiveKey(null);
    setSelectedMachine(ms);
  };

  const toggleAccordion = () => {
    if (activeKey === "0") {
      setActiveKey(null);
    } else {
      setActiveKey("0");
    }
  };

  return (
    <div>
      <div style={{ float: "right" }}>
        <div style={{ fontSize: "16px", fontWeight: "bold" }}>
          Next Update On : {nextWeek}
        </div>
        <div style={{ fontSize: "16px", fontWeight: "bold" }}>
          Countdown : {remainingDays}
        </div>
      </div>
      <h1 className="page-header">
        Weekly Analytics :{" "}
        <span>
          {weekBefore} - {lastWednesday}
        </span>
      </h1>

      <div className="row" data-masonry='{"percentPosition": true }'>
        <div
          className="col-lg-6 col-xl-6 col-sm-12 mb-4"
          style={{ height: "90px", position: "relative" }}
        >
          <Accordion
            style={{ position: "absolute", zIndex: "11", width: "100%" }}
            defaultActiveKey=""
            activeKey={activeKey}
            onSelect={toggleAccordion}
          >
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                {selectedMachine
                  ? selectedMachine.metadata?.location_name +
                    " | " +
                    selectedMachine.name
                  : "- Please Select Machine -"}
              </Accordion.Header>
              <Accordion.Body style={{ padding: 0 }}>
                <StructureView clickMachine={onChangeTree} />
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      </div>
      <div className="row" style={{ position: "relative", zIndex: "1" }}>
        <div className="col-6">
          <div className="mt-3">
            {machineHealth.length > 0 && (
              <>
                {machineHealth.map((mh, i) => (
                  <MachineHealthDetail
                    key={i}
                    data={mh}
                    filteredDate={reportDate}
                  />
                ))}
              </>
            )}
            <Card className="mb-4">
              <CardHeader>Live Sensor Data</CardHeader>
              <CardBody>
                <Tabs
                  id="controlled-tab-example"
                  activeKey={key}
                  onSelect={(k) => setKey(k)}
                  className="mb-3"
                >
                  {getSensors().map((item, index) => {
                    return (
                      <Tab
                        eventKey={"tab" + index}
                        title={item.machine_element_name}
                      >
                        {/*        /!*only render if key are active*!/*/}
                        {key == "tab" + index && (
                          <LiveChart
                            filteredDate={reportDate}
                            onlyVibration={true}
                            sensorData={item}
                            machineId={selectedMachine?.id}
                            machineDetail={machineDetail}
                          />
                        )}
                      </Tab>
                    );
                  })}
                </Tabs>
              </CardBody>
            </Card>
          </div>
        </div>
        <div className="col-6">
          <div className="mt-3">
            {lastMachineHealth.length > 0 && (
              <>
                {lastMachineHealth.map((mh, i) => (
                  <MachineHealthDetail
                    key={i}
                    data={mh}
                    filteredDate={reportDate2}
                  />
                ))}
              </>
            )}
            <Card className="mb-4">
              <CardHeader>Live Sensor Data</CardHeader>
              <CardBody>
                <Tabs
                  id="controlled-tab-example"
                  activeKey={key}
                  onSelect={(k) => setKey(k)}
                  className="mb-3"
                >
                  {getSensors().map((item, index) => {
                    return (
                      <Tab
                        eventKey={"tab" + index}
                        title={item.machine_element_name}
                      >
                        {/*        /!*only render if key are active*!/*/}
                        {key == "tab" + index && (
                          <LiveChart
                            filteredDate={reportDate2}
                            onlyVibration={true}
                            sensorData={item}
                            machineId={selectedMachine?.id}
                            machineDetail={machineDetail}
                          />
                        )}
                      </Tab>
                    );
                  })}
                </Tabs>
              </CardBody>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Weekly;
